import { useEffect, useRef, useState } from 'react';
import DynamicTableComponentForMetaData from '../DynamicTable/DynamicTableComponentForMetaData';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../app/stores/store';
import agent from '../../app/api/agent';
import _ from 'lodash';
import UnauthorizedMessage from '../UnauthorizedMessage';
import { uniqByKeepLast } from './smarttrackerType';
import { observer } from 'mobx-react-lite';
interface Props {
  selectedItems:{
    task: string;
    subtask: string;
    }
    setSelectedItems:any
    clickTaskHandler:any
    currentTitle_Code:any;
    setCurrentTitle_Code:any;
    currentPl_id:any;
    setCurrentPl_id:any;
    currentDisplayName:any;
    setCurrentDisplayName:any;
    getNewDetails:any
}
function SmartTrackerReports(
  Props:Props
) {
  const {
    selectedItems={
      task: '',
      subtask: '',
    },
    clickTaskHandler,
    currentTitle_Code,
    setCurrentTitle_Code,
    currentPl_id,
    setCurrentPl_id,
    currentDisplayName,
    setCurrentDisplayName,
    getNewDetails
  } = Props
  //Store
  const {
    dashboardStore,
    reportStore,
    metaDataStore,
    commonStore,
    TrackingReportStore,
  } = useStore();
  const { DropdownParentAll, dropDowndata } = metaDataStore;
  const {
    loadReportPagination,
    loadingDataReport,
    metaDataRegistry,
    metaDataPaginationAll,
  } = reportStore;
  const [smartTrackerData, setSmartTrackerData] = useState<any[]>([]);

  const { userReadableDateFormatMetaData } = commonStore;
  // local storage

  const previousSubTaskValue = useRef(selectedItems.subtask);
    const previousPlIdValue = useRef(currentPl_id.value);
  const previousDisplayNameValue = useRef(currentDisplayName.value);
  const previousTitleCodeValue = useRef(currentTitle_Code.value);
  const [pageNumber, setPageNumber] = useState(
    dashboardStore.dashboard.setReportsPageNum,
  );
  const [groupItems] = useState<any[]>([]);
  // const [smartTrackerData, setSmartTrackerData] = useState<any[]>([]);

  // const duplicateFilter = useRef<any[]>([]);

  let localStoreageItem: any = localStorage.getItem('SmartTracker');
  useEffect(() => {
    TrackingReportStore.statusButtonShow('');
    reportStore.withoutAllworkflow();
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    (async () => {

      const update = async () => {
        const titleCode = await agent.SmartTracker.titleCodeGet();
        const PlEmpId = await agent.SmartTracker.plEmpIdGet();
        const opratorEmpId = await agent.SmartTracker.OperationEmpIdGet();
        if (titleCode.data) {
          setCurrentTitle_Code({
            ...currentTitle_Code,
            list: uniqByKeepLast(titleCode.data),
          });
        }
        if (PlEmpId.data) {
          setCurrentPl_id({
            ...currentPl_id,
            list: uniqByKeepLast(PlEmpId.data),
          });
        }
        if (opratorEmpId.data) {
          setCurrentDisplayName({
            ...currentDisplayName,
            list: uniqByKeepLast(opratorEmpId.data),
          });
        }
      };

      if (groupItems && commonStore.RestorationCustomer) {
        update();
      }
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedItems.task === '') {
      setPageNumber(1);
    } else {
      // Check if any of the dropdown values have changed
      const dropdownValuesChanged: boolean =
        currentPl_id.value !== previousPlIdValue.current ||
        currentDisplayName.value !== previousDisplayNameValue.current ||
        currentTitle_Code.value !== previousTitleCodeValue.current;
        
      // Check if currentTask or currentSubTask have changed
      const taskOrSubTaskChanged: boolean =
        !!selectedItems.task ||
        selectedItems.subtask !== previousSubTaskValue.current;

      if (taskOrSubTaskChanged &&  !TrackingReportStore.productionPlanning.dropdownChanges) {
        getNewDetails(1);
        setPageNumber(1);
        previousSubTaskValue.current = selectedItems.subtask;
      } else if (dropdownValuesChanged &&  !TrackingReportStore.productionPlanning.dropdownChanges) {
        getNewDetails(1);
        setPageNumber(1);
        previousPlIdValue.current = currentPl_id.value;
        previousDisplayNameValue.current = currentDisplayName.value;
        previousTitleCodeValue.current = currentTitle_Code.value;
      } else {
        //empty
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedItems.task,
    selectedItems.subtask,
    currentPl_id.value,
    currentTitle_Code.value,
    currentDisplayName.value,
  ]);

  useEffect(() => {
    dashboardStore.dashboard.setTagTablePageNumber === 1 &&
      setPageNumber(dashboardStore.dashboard.setTagTablePageNumber);
  }, [dashboardStore.dashboard.setTagTablePageNumber]);

  useEffect(() => {
    TrackingReportStore.statusButtonShow('');
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const tableData: any[] = [];

    metaDataPaginationAll?.forEach((a) => {
      delete a?.isMaster;
      // eslint-disable-next-line
      delete a?.sections_Multiple_From;
      delete a?.sections_From;
      tableData?.push({
        ...a,
        movementdate: userReadableDateFormatMetaData(a.movementdate),
        movement_Time: userReadableDateFormatMetaData(a.movement_Time),
        maintenance: userReadableDateFormatMetaData(a.maintenance),
        receivingdate: userReadableDateFormatMetaData(a.receivingdate),
        status_Time: userReadableDateFormatMetaData(a.status_Time),
        itemCreatedAt: userReadableDateFormatMetaData(a.itemCreatedAt),
      });
    });

    const removeCol =
      'isdeleted,isActive,isReceiving,isDelivery,isReceivingOrder';
    const reportsTable = JSON.parse(JSON.stringify(tableData));
    reportsTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));
    setSmartTrackerData(reportsTable);
    // eslint-disable-next-line
  }, [metaDataRegistry, metaDataPaginationAll, loadingDataReport]);

  //Function
  
  const paginateFunction = (e: number) => {
    TrackingReportStore.statusButtonShow('');
    TrackingReportStore.bindComponent.model = false;
    TrackingReportStore.ActiveRowId='';
    dashboardStore.dashboard.searchfilterparams[`current_task`] =
      selectedItems.task;
    dashboardStore.dashboard.searchfilterparams[`current_subtask`] =
      selectedItems.subtask;
    dashboardStore.dashboard.searchfilterparams[`metadata/ title_code`] =
      currentTitle_Code.value;
    dashboardStore.dashboard.searchfilterparams[`metadata/ pl_name`] =
      currentPl_id.value;
    dashboardStore.dashboard.searchfilterparams[`metadata/ displayname`] =
      currentDisplayName.value;
    if (selectedItems.task === '') {
      delete dashboardStore.dashboard.searchfilterparams[`current_task`];
    }
    if (selectedItems.subtask === '') {
      delete dashboardStore.dashboard.searchfilterparams[`current_subtask`];
    }
    if (currentTitle_Code.value === '') {
      delete dashboardStore.dashboard.searchfilterparams[
        `metadata/ title_code`
      ];
    }
    if (currentPl_id.value === '') {
      delete dashboardStore.dashboard.searchfilterparams[`metadata/ pl_name`];
    }
    if (currentDisplayName.value === '') {  
      delete dashboardStore.dashboard.searchfilterparams[
        `metadata/ displayname`
      ];
    }

    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      if (localStoreageItem?.split(',')) {
        let ReportTableChosenId = localStoreageItem?.split(',');
        ReportTableChosenId.push('id');
        const lower = ReportTableChosenId.map((element: any) => {
          return element?.toLowerCase();
        });
        if(['Wave Production','CC Form Production','QT Processes'].includes(selectedItems.subtask)){
          if(selectedItems.subtask === '') {
            metaDataRegistry.clear();
            return;
          }
         TrackingReportStore.reelSmartrackerSearchShow(currentTitle_Code.value,selectedItems.subtask) 
        }else  reportStore.searchMetaDataReport(
          e,
          dashboardStore.dashboard.searchfilterparams,
          lower,
          commonStore.RestorationCustomer ? 'SmartTracker' : '',
        );
      } else {
        let ReportTableChosenId = [localStoreageItem];
        ReportTableChosenId.push('id');
        const lower = ReportTableChosenId.map((element: any) => {
          return element?.toLowerCase();
        });
        if(['Wave Production','CC Form Production','QT Processes'].includes(selectedItems.subtask)){
          if(selectedItems.subtask === '') {
            metaDataRegistry.clear();
            return;
          }
         TrackingReportStore.reelSmartrackerSearchShow(currentTitle_Code.value,selectedItems.subtask) 
        }else  reportStore.searchMetaDataReport(
          e,
          dashboardStore.dashboard.searchfilterparams,
          lower,
          commonStore.RestorationCustomer ? 'SmartTracker' : '',
        );
      }
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      let chosenArr = localStoreageItem.split(',');
      chosenArr.push('id');
      reportStore.sortMetaDataReport(
        dashboardStore.dashboard.orderName,
        dashboardStore.dashboard.orderData,
        e,
        chosenArr!,
      ); //api call
      //   activityStore.sortListItems(dashboardStore.dashboard.orderName,dashboardStore.dashboard.orderData,e,5);//api call
    } else {
      let chosenArr = localStoreageItem.split(',');
      chosenArr.push('id');
      const lower = chosenArr.map((element: any) => {
        return element?.toLowerCase();
      });
      // let searchValues = dashboardStore.dashboard.searchfilterparams;
      if (DropdownParentAll === 'Parent') {
        reportStore.parentOptionApi(e, lower);
      } else {
        loadReportPagination(e, lower, 'SmartTracker');
      }
    }
    dashboardStore.setReportsPageNum(e);
    setPageNumber(e);
  };

  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };

  // if (loadingDataReport) return <LoadingComponent />;
  return (
    <>
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('DB02') && <UnauthorizedMessage />}
      {commonStore.filterModeOne.includes('DB02') && (
        <div style={{ overflow: 'auto'}}>
          {
            <DynamicTableComponentForMetaData
              key={uuid()}
              data={(smartTrackerData || [])?.filter(
                (d: any) => d.status !== 'Completed'
              )}
              name={'SmartTracker'}
              actiontype={''}
              clickTaskHandler={clickTaskHandler}
              pageFunc={paginateFunction}
              pageNumData={pageNumber}
              searchFuncData={searchFunction}
              DropdownParentAll={DropdownParentAll}
              dropDowndata={dropDowndata}
              currentTitle_Code={currentTitle_Code}
              setCurrentTitle_Code={setCurrentTitle_Code}
              currentPl_id={currentPl_id}
              setCurrentPl_id={setCurrentPl_id}
              currentDisplayName={currentDisplayName}
              setCurrentDisplayName={setCurrentDisplayName}
              getNewDetails={getNewDetails} 
              setPageNumber={setPageNumber}
            />
          }
        </div>
      )}
    </>
  );
}

export default observer(SmartTrackerReports);
